import { canEditPlanUtil } from '../../../../modules/plan/model/utils/can-edit'
import getByIdPlanSelector from '../get-by-id'
import { getCurrentProfileSelect } from '../../../profile/redux/selectors/get-current'
import isAdminProfileSelect from '../../../profile/redux/selectors/is-admin'
import { createSelector } from 'reselect'

function canEditByIdPlanSelector (id) {
  return createSelector(
    getByIdPlanSelector(id),
    getCurrentProfileSelect,
    isAdminProfileSelect,
    (instance, profile, isProfileAdmin) => {
      return (
        canEditPlanUtil(instance, profile) || isProfileAdmin
      )
    }
  )
}

export default canEditByIdPlanSelector
